import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import NavBar from './components/NavBar/navbar';
import Intro from './components/Intro/intro';
import About from './components/About/about';
import Contract from './components/Contact/contact';
import Footer from './components/Footer/footer';
import Project from './components/Project/project';
import Blog from './components/Blog/blog';
import BlogDetail from './components/Blog/BlogDetail';

// Home page layout
function Home() {
  return (
    <>
      <Intro />
      <About />
      <Project />
      <Blog />
      <Contract />
    </>
  );
}

function App() {
  return (
    <Router>
      <NavBar />

      <Routes>
        {/* Home Page */}
        <Route path="/" element={<Home />} />

        {/* Blog Detail Page */}
        <Route path="/blog/:slug" element={<BlogDetail />} />
      </Routes>

      <Footer />
    </Router>
  );
}

export default App;


// import NavBar from './components/NavBar/navbar';
// import Intro from './components/Intro/intro';
// import About from './components/About/about'; 
// import Contract from './components/Contact/contact';
// import Footer from './components/Footer/footer';
// import Project from './components/Project/project';
// import Blog from './components/Blog/blog';

// function App() {
//   return (
//     <div className="App">
//       <NavBar />
//       <Intro />
//       <About />
//       <Project />
//       <Blog />
//       <Contract />
//       <Footer />
//     </div>
//   );
// }

// export default App;
